
import { combineEpics } from 'redux-observable';
import { autoMiner, backgroundMiner } from './block-mining-epics.js';
import { merkleFiles, merkleTree } from './merkle-epics.js'
import { transactionsInit } from './transactions-epics.js'
import { generateRandomSeed } from './publickey-epics.js'

const rootEpic = combineEpics(
    autoMiner,
    backgroundMiner,
    merkleFiles,
    merkleTree,
    transactionsInit,
    generateRandomSeed,
);

export { rootEpic as default };







// WEBPACK FOOTER //
// ./src/epics/index.js